import { logger } from '@/ui'
import { loadStripe, type Stripe } from '@stripe/stripe-js'

const stripePromiseCache = new Map<string, Promise<Stripe | null>>()

/**
 * One instance per publishable key: Stripe.js must use the key of the Stripe
 * account (Oy, DACH) that owns the SetupIntent / PaymentIntent.
 */
export function getStripe(publishableKey?: string | null): Promise<Stripe | null> {
	const key = publishableKey ?? import.meta.env.VITE_STRIPE_PUBLISHABLE_KEY

	if (!key) {
		logger.error(new Error('Missing Stripe publishable key'))
		return Promise.resolve(null)
	}

	let promise = stripePromiseCache.get(key)

	if (!promise) {
		promise = loadStripe(key).catch((error: unknown) => {
			stripePromiseCache.delete(key)
			throw error
		})
		stripePromiseCache.set(key, promise)
	}

	return promise
}
